import React, { useState } from 'react'

import { Button, Dropdown, Menu } from 'antd'

import { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'

import { Col, Row } from 'common/components'

import { parseZone, parseZoneFormat } from '../../../dateFormatters'
import Icon from '../../general/Icon'

import './styles.less'

type BenefitPlanPeriodDropDownProps = {
  planPeriods: PlanPeriodDto[]
  defaultValue?: string
  text?: string
  showStartDateAndEndDate?: boolean
  onPlanPeriodSelected?: (planPeriodId: string) => void
}

const BenefitPlanPeriodDropDown: React.FC<BenefitPlanPeriodDropDownProps> = (props) => {
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto>(
    props.defaultValue
      ? props.planPeriods.find((x) => x.id === props.defaultValue)
      : props.planPeriods.find((x) => x.active == true) ?? props.planPeriods[0],
  )

  return (
    <>
      {props.planPeriods && props.planPeriods.length > 1 && (
        <Row className="benefit-plan-period-drop-down" align={'middle'}>
          <Col className="benefit-plan-period-drop-down-plan bg-gray-2 pl-8 pr-8">
            {props.text ? props.text : 'Benefit plan year'}
          </Col>
          <Col>
            <Dropdown
              overlay={
                <Menu
                  onClick={(key) => {
                    setSelectedPlanPeriod(props.planPeriods.find((x) => x.id === key.key))

                    if (props.onPlanPeriodSelected) {
                      props.onPlanPeriodSelected(key.key)
                    }
                  }}
                >
                  {props.planPeriods.map((item) => {
                    return (
                      <Menu.Item key={item.id}>
                        <span>
                          {props.showStartDateAndEndDate && !item.isContinuous
                            ? `${parseZoneFormat(item.startDate)} - ${parseZoneFormat(item.endDate)}`
                            : props.showStartDateAndEndDate && item.isContinuous
                            ? `${parseZoneFormat(item.startDate)} - Continuous`
                            : parseZone(item.startDate).year()}
                        </span>
                      </Menu.Item>
                    )
                  })}
                </Menu>
              }
              trigger={['click']}
              placement="bottomLeft"
            >
              <Button className="ant-dropdown-link grey-link ml-8 dropdown-btn" onClick={(e) => e.preventDefault()}>
                {props.showStartDateAndEndDate && !selectedPlanPeriod.isContinuous
                  ? `${parseZoneFormat(selectedPlanPeriod.startDate)} - ${parseZoneFormat(selectedPlanPeriod.endDate)}`
                  : props.showStartDateAndEndDate && selectedPlanPeriod.isContinuous
                  ? `${parseZoneFormat(selectedPlanPeriod.startDate)} - Continuous `
                  : parseZone(selectedPlanPeriod.startDate).year()}
                <Icon type="far fa-angle-down" className="ml-4" fontAwesome />
              </Button>
            </Dropdown>
          </Col>
        </Row>
      )}
    </>
  )
}

export default BenefitPlanPeriodDropDown
